var _defs, _path, _path2, _line, _line2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f385309e-fd55-47bd-b119-92250a69092b",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a49ab4f4-390f-4f97-a9b4-8515d0f41e63,.e8bef2b8-a447-469d-a884-d764b50041b8{fill:none;}.a49ab4f4-390f-4f97-a9b4-8515d0f41e63,.b1645e7d-d774-4c7d-a729-9a2d29d9632a{stroke:#8e8e8e;}.a49ab4f4-390f-4f97-a9b4-8515d0f41e63,.b1645e7d-d774-4c7d-a729-9a2d29d9632a,.e8bef2b8-a447-469d-a884-d764b50041b8{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.af527172-5684-4ae8-9593-7da31b132cc9,.b1645e7d-d774-4c7d-a729-9a2d29d9632a{fill:#228ad2;}.e8bef2b8-a447-469d-a884-d764b50041b8{stroke:#645346;}.aa282590-fb3a-4340-a886-bcae34915f0f{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "txt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a49ab4f4-390f-4f97-a9b4-8515d0f41e63",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b1645e7d-d774-4c7d-a729-9a2d29d9632a",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e8bef2b8-a447-469d-a884-d764b50041b8",
    x1: 61,
    y1: 41.1,
    x2: 32.8,
    y2: 41.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e8bef2b8-a447-469d-a884-d764b50041b8",
    x1: 61,
    y1: 50.9,
    x2: 32.8,
    y2: 50.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "af527172-5684-4ae8-9593-7da31b132cc9",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "aa282590-fb3a-4340-a886-bcae34915f0f",
    d: "M45.9,63.3H42.8V62.2h7.5v1.1H47.2v9H45.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "aa282590-fb3a-4340-a886-bcae34915f0f",
    d: "M57.3,72.3,56,70.1c-.5-.9-.9-1.4-1.2-2h0l-1.1,2-1.2,2.2H51l3.1-5.1-3-5h1.5l1.3,2.4,1,1.7h0l.9-1.7,1.4-2.4h1.5l-3.1,4.9,3.2,5.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "aa282590-fb3a-4340-a886-bcae34915f0f",
    d: "M62.3,63.3h-3V62.2h7.4v1.1h-3v9H62.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.9c13d41a48491ee8c74edd147a030faa.svg";
export { ForwardRef as ReactComponent };